import React, { useCallback } from 'react';
import * as PropTypes from 'prop-types';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { CustomOption } from 'components/forms/form-fields/select/fragments/custom-option';
import { ValueContainer } from 'components/forms/form-fields/select/fragments/value-container';
import { memoize, isEmpty } from 'lodash-es';
import { getHash } from 'utils/hash';

export const MultiSelect = ({
  isSearchable = true,
  hideSelectedOptions = false,
  className = '',
  closeMenuOnSelect = false,
  selectedValues = [],
  creatableOptions,
  options,
  isMulti,
  placeholder,
  isDisabled,
  onChange,
  onInputChange,
  noOptionsMessage
}) => {
  // Memoized function returns unknown dependencies but we don't care about those
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const _getSelectableValue = useCallback(
    memoize(
      (selectedValues, options) => {
        return selectedValues.map((id) => options.find((o) => o.id === id));
      },
      (...args) => getHash(JSON.stringify(args))
    ),
    []
  );

  const getSelectableValue = (selectedValues, options) => {
    if (!Array.isArray(selectedValues) || isEmpty(selectedValues) || isEmpty(options)) {
      return [];
    }
    return _getSelectableValue(selectedValues, options);
  };
  return (
    <div data-e2e="ct-multi-select">
      {creatableOptions ? (
        <CreatableSelect
          components={{
            Option: CustomOption,
            ValueContainer,
          }}
          options={options}
          value={selectedValues}
          isMulti={isMulti}
          isSearchable={isSearchable}
          placeholder={placeholder}
          isDisabled={isDisabled}
          className={`ct-select ${className}`}
          hideSelectedOptions={hideSelectedOptions}
          closeMenuOnSelect={closeMenuOnSelect}
          onChange={onChange}
          createOptionPosition="first"
          onInputChange={onInputChange}
          noOptionsMessage={noOptionsMessage}
        />
      ) : (
        <Select
          components={{
            Option: CustomOption,
            ValueContainer,
          }}
          options={options}
          value={getSelectableValue(selectedValues, options)}
          isMulti={isMulti}
          isSearchable={isSearchable}
          placeholder={placeholder}
          isDisabled={isDisabled}
          className={`ct-select ${className}`}
          hideSelectedOptions={hideSelectedOptions}
          closeMenuOnSelect={closeMenuOnSelect}
          getOptionValue={(option) => option.id}
          onChange={onChange}
        />
      )}
    </div>
  );
};

MultiSelect.propTypes = {
  input: PropTypes.any,
  options: PropTypes.any,
  isMulti: PropTypes.bool,
  isSearchable: PropTypes.bool,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  isDisabled: PropTypes.bool,
  className: PropTypes.string,
  hideSelectedOptions: PropTypes.bool,
  closeMenuOnSelect: PropTypes.bool,
  selectedValues: PropTypes.array,
  onChange: PropTypes.func,
  noOptionsMessage: PropTypes.func,
};
